export default __webpack_public_path__ + "static/media/image9.03d7d1b9.jpg";